import {
  gridColumnDefinitionsSelector,
  gridSortModelSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import { SortDrawer, type SortValue } from './SortDrawer';

type ToolbarSortItemProps = {
  listView: boolean;
  title: string;
};

export function ToolbarSortItem({ listView, title }: ToolbarSortItemProps) {
  const apiRef = useGridApiContext();
  const fields = useGridSelector(apiRef, gridColumnDefinitionsSelector);
  const sortModel = useGridSelector(apiRef, gridSortModelSelector);
  const sortableFields = fields.filter((field) => field.sortable);
  const value: SortValue[] = sortModel.flatMap(({ field, sort }) => (sort ? [{ field, direction: sort }] : []));

  return (
    <SortDrawer
      options={sortableFields.map(({ field, headerName }) => ({ field, label: headerName || field }))}
      value={value}
      onChange={(newValue) =>
        apiRef.current.setSortModel(newValue.map(({ field, direction }) => ({ field, sort: direction })))
      }
      fullWidth={listView}
      title={title}
    />
  );
}
